import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadchrumb from "../components/Breadchrumb";
import { getProducts } from "../data/products"; // renamed for clarity

const ProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProduct() {
      try {
        const products = await getProducts();
        const found = products.find((item) => item._id === id);
        setProduct(found || null);
      } catch (err) {
        console.error("Error fetching product:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchProduct();
  }, [id]);

  useEffect(() => {
    if (product) {
      document.title = `${product.name} | JB Corporation Ahmedabad Gujarat`;
    }
  }, [product]);

  if (loading) {
    return (
      <div style={{ padding: "4rem", textAlign: "center" }}>
        <h2>Loading product details...</h2>
      </div>
    );
  }

  if (!product) {
    return (
      <div style={{ padding: "4rem", textAlign: "center" }}>
        <h2>Product not found</h2>
      </div>
    );
  }

  return (
    <>
      <Breadchrumb pageName={product.name} />

      <section className="product-details">
        <div className="container">
          {/* LEFT IMAGE */}
          <div className="product-details-image">
            <img src={product.imageUrl} alt={product.name} />
          </div>

          {/* RIGHT DETAILS */}
          <div className="product-info">
            <h2>{product.name}</h2>
            <p className="desc">{product.description}</p>

            <ul className="features">
              {product.features?.map((feature, index) => (
                <li key={index}>
                  <i className="fa-solid fa-check"></i> {feature}
                </li>
              ))}
            </ul>

            <div className="product-buttons">
              <a
                  href={product?.brochureUrl || '/JB-New-Catlog.pdf'}
                  className="btn primary-btn"
                  download
                >
                  📘 Download Brochure
                </a>
              <a href="/contact" className="btn secondary-btn">
                📞 Get a Quote
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDetails;
